import type { AdminRecordListItemDTO } from "@/application/records/dtos/RecordListItemDTO";
import type { RecordsGatewayPort } from "@/application/records/ports/RecordsGatewayPort";

export interface FetchAdminRecordsListInputDto {
  page?: number;
  limit?: number;
}

/**
 * Use case: полный список записей в режиме администратора.
 */
export class FetchAdminRecordsListUseCase {
  constructor(private readonly gateway: RecordsGatewayPort) {}

  async execute(
    input: FetchAdminRecordsListInputDto = {}
  ): Promise<AdminRecordListItemDTO[]> {
    return this.gateway.getAdminRecordsList(input.page, input.limit);
  }
}
